export default "__VITE_ASSET__DNuaDeBC__"